module.exports = __webpack_public_path__ + "img/up-chevron.6aa53cf3.svg";